import { textureHeight, textureWidth } from "./Model.fs.js";
import { comparePrimitives, min, createAtom } from "./fable_modules/fable-library.3.7.14/Util.js";
import { startAsPromise } from "./fable_modules/fable-library.3.7.14/Async.js";
import { init } from "./CrossPlatform/Game.fs.js";
import { initScene } from "./Scene.fs.js";
import { some } from "./fable_modules/fable-library.3.7.14/Option.js";

export const canvas = document.querySelector(".game-canvas");

export const loadingImage = (() => {
    let returnVal = new Image(textureWidth, textureHeight);
    returnVal.src = "assets/loadingScreen.png";
    return returnVal;
})();

export let isShowingLoadingScreen = createAtom(true);

export function drawImage(_arg1) {
    const context = canvas.getContext('2d');
    context.imageSmoothingEnabled = false;
    const aspectRatio = min(comparePrimitives, canvas.width / loadingImage.width, canvas.height / loadingImage.height);
    const renderHeight = loadingImage.height * aspectRatio;
    const renderWidth = loadingImage.width * aspectRatio;
    const xPos = (canvas.width - renderWidth) / 2;
    const yPos = (canvas.height - renderHeight) / 2;
    context.drawImage(loadingImage, xPos, yPos, renderWidth, renderHeight);
}

loadingImage.onload = ((arg00$0040) => {
    drawImage(arg00$0040);
});

export function setCanvasSize(_arg1) {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
}

window.onresize = ((_arg1) => {
    setCanvasSize();
    if (isShowingLoadingScreen()) {
        drawImage();
    }
});

setCanvasSize();

function controlStateFromKeyCode(keyCode) {
    switch (keyCode) {
        case "ArrowUp": {
            return 1;
        }
        case "ArrowLeft": {
            return 2;
        }
        case "ArrowRight": {
            return 4;
        }
        case "KeyQ": {
            return 8;
        }
        case "KeyE": {
            return 16;
        }
        case "ArrowDown": {
            return 32;
        }
        case "ControlLeft": {
            return 64;
        }
        case "Space": {
            return 128;
        }
        case "Digit1": {
            return 256;
        }
        case "Digit2": {
            return 512;
        }
        case "Digit3": {
            return 1024;
        }
        case "Digit4": {
            return 2048;
        }
        default: {
            return 0;
        }
    }
}

export const initialisationPromise = startAsPromise(init(1, () => initScene(canvas, void 0)));

initialisationPromise.then((tupledArg) => {
    const controlStateHandler = tupledArg[1];
    isShowingLoadingScreen(false, true);
    let previousTimestamp = 0;
    let currentGameState = tupledArg[2];
    const wrappedGameLoop = (timestamp) => {
        const timeInFrame = min(comparePrimitives, 1000 / 30, timestamp - previousTimestamp);
        previousTimestamp = timestamp;
        currentGameState = tupledArg[0](currentGameState)(timeInFrame * 1);
        window.requestAnimationFrame(wrappedGameLoop);
    };
    window.onkeydown = ((ke) => {
        if (!ke.repeat) {
            const controlState = controlStateFromKeyCode(ke.code) | 0;
            if (controlState !== 0) {
                ke.preventDefault();
                currentGameState = controlStateHandler(currentGameState)(controlState);
            }
        }
    });
    window.onkeyup = ((ke_1) => {
        const controlState_1 = controlStateFromKeyCode(ke_1.code) | 0;
        if (controlState_1 !== 0) {
            ke_1.preventDefault();
            currentGameState = controlStateHandler(currentGameState)(controlState_1);
        }
    });
    window.requestAnimationFrame(wrappedGameLoop);
}).catch((exn) => {
    console.error(some(`Error initialising engine ${exn}`));
});

